window.inn = window.inn || {};
const contextPath = /\/sso\//.test(window.inn.uri) ? '/sso/' : '/oidsso/';

export const userExistUrl = `${contextPath}user_exist`;
export const getPinUrl = `${contextPath}getPin`;
export const opplysningenLookupUrl = `${contextPath}opplysningen_lookup`;
export const CRMDataUrl = `${contextPath}profile`;
export const loginUrl = `${contextPath}welcome`;
export const passwordLoginUrl = `${contextPath}user_pw_exist`;
export const conditionsUrl = `${contextPath}conditions`;
export const resetPasswordUrl = `${contextPath}resetpassword`;
export const accessLogUrl = `${contextPath}get_user_accesslog`;
export const applicationsUrl = `${contextPath}list_applications`;
export const verifyEmailUrl = `${contextPath}verify/email_send_token`;
export const pinTroubleShooterUrl = `${contextPath}troubleshooter`;
export const ListConsentDataUrl = `${contextPath}list_consentdata`;
export const UpdateConsentDataUrl = `${contextPath}update_consentdata`;
export const ToggleSharingConsentDataUrl = `${contextPath}toggle_sharing_consentdata`;
export const DeleteConsentDataUrl = `${contextPath}delete_consentdata`;
export const postConsentScreenUrl = `${contextPath}consent_sharing_default_address`;
export const ListTraqConsentDeclarationDataUrl = `${contextPath}consent/declaration`;
export const ListTraqMyConsentDataUrl = `${contextPath}consent/refresh`;
export const CreateTraqConsentUrl = `${contextPath}consent/create`;
export const WithdrawTraqConsentUrl = `${contextPath}consent/withdraw`;
export const vippsCheckExistsUrl = `${contextPath}user_vipps_exist`;
export const vippsLoginUrl = `${contextPath}vipps/login`;
export const getPinForTrustedClientUrl = `${contextPath}getPinForTrustedClient`;
